import type { ReactNode } from 'react';

type Props = {
  title: string;
  description?: string;
  planTag?: string;
  children?: ReactNode;
};

export function EmptyState({ title, description, planTag, children }: Props): JSX.Element {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col items-center justify-center p-10 text-center min-h-[200px]">
      <h2 className="text-lg font-semibold text-gray-800 mb-2">{title}</h2>
      {description && (
        <p className="text-sm text-gray-500 max-w-md mb-4">{description}</p>
      )}
      {planTag && (
        <span className="inline-block rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-700 border border-slate-200">
          {planTag}
        </span>
      )}
      {children}
    </div>
  );
}
